class ClearInput {
  constructor() {
    const wraps = [...document.querySelectorAll('.clearable-wrap')];
    wraps.map(wrap => {
      wrap.setAttribute('data-bound', true);
      const input = wrap.querySelector('#id_promo_code');
      const button = wrap.querySelector('.clear-input');

      input.addEventListener('input', () => {
        this.toggleClass(input, button);
      });

      button.addEventListener('click', event => {
        event.preventDefault();
        input.value = '';
        // placeholder.toggleClass(input);
        this.toggleClass(input, button);
        wrap.classList.remove('promo-valid');
      });
    });
  }

  toggleClass(input, button) {
    if (input.value.length > 0) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }
  }
}

export default new ClearInput();



// WEBPACK FOOTER //
// ./src/js/clear-input.js